import { render, staticRenderFns } from "./orderCgLdApprove.vue?vue&type=template&id=228307a3&scoped=true"
import script from "./orderCgLdApprove.vue?vue&type=script&lang=js"
export * from "./orderCgLdApprove.vue?vue&type=script&lang=js"
import style0 from "./orderCgLdApprove.vue?vue&type=style&index=0&id=228307a3&prod&scoped=true&lang=css"
import style1 from "./orderCgLdApprove.vue?vue&type=style&index=1&id=228307a3&prod&lang=css"
import style2 from "./orderCgLdApprove.vue?vue&type=style&index=2&id=228307a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228307a3",
  null
  
)

export default component.exports